module.exports = __webpack_public_path__ + "img/cover.cc511f82.jpg";